<template>
  <v-dialog v-model="localShow" max-width="90%" persistent>
    <v-card flat style="background-color: transparent!important;">
      <v-btn
        icon
        x-small
        class="floating-close-button"
        @click="handleClose"
        style="position:absolute;top:3px;right:27px;z-index:10;"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-card-text style="padding: 0; height: 85vh;">
        <div style="position: relative; width: 100%; height: 100%;">
          <iframe
            :src="`https://becompliance.storylane.io/demo/${embedHash}`"
            frameborder="0"
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
            allowfullscreen
            loading="lazy"
            name="sl-embed"
          ></iframe>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "StorylaneEmbed",
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    embedHash: {
      type: String,
      default: "wmpair9wslhc",
      required: true,
    },
  },
  data() {
    return {
      localShow: false,
    };
  },
  watch: {
    show(val) {
      this.localShow = val;
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
      this.localShow = false;
    },
  },
};
</script>

<style scoped>
.floating-close-button {
  color: white;
}
</style>
